/**
 * common模块，公共方法模块，主要负责业务上常用方法
 *
 * @author lianghua.fu
 * @update 2016-01-26 10:34:29
 *
 * 公用方法
 *
 * lastTime            : 计算持续时间,
 * getLastDay          : 获取时长，精确到小时,
 * formatTime          : 格式化时间，按照不同的格式返回不同的字符串,
 * getNow              : 获取当前时间，只包含小时和分钟,
 * createCount         : 创建用户数量,
 * formatNum           : 格式化数字,
 * createAuthCode      : 创建验证码,
 * bytesLength         : 计算字符串长度，双字符如汉子算两个,
 * track               : 百度行为统计
 * getAppUrl           : 获取App下载地址
 * openDownload        : 下载App
 * showNoMoney         : 余额不足充值
 */

import { getInitFunc } from 'lib/gt';

$.module('MM.common', function () {
  /**
   * 计算持续时间
   * @param  {Number} time 时间长度，单位是秒
   * @param  {String} type 是否返回的类型 (str, timer)
   * @param  {String} acr  精确到哪一位 (h/m/s)
   * @param  {boolen} isFormat  true格式化成  01：50：06（时分秒补零）
   * @return {String/Object}     返回对应的时间
   */
  function _lastTime(time, type, acr, isFormat) {
    var result = {
        h: Math.floor(time / 3600),
        m: Math.floor((time % 3600) / 60),
        s: Math.floor(time % 60),
      },
      str = '';

    acr = acr || 's';

    for (var key in result) {
      var value = result[key];
      result[key] = value < 10 && isFormat ? '0' + value : value;
    }

    if (type == 'str') {
      if (result.h > 0) {
        str += result.h + '小时';
      }

      if (result.m > 0) {
        str += acr !== 'h' ? result.m + '分钟' : '';
      }

      if (result.s > 0 && !(result.m > 0 || result.h > 0)) {
        str += acr !== 's' ? '' : result.s + '秒';
      }

      return str;
    }

    return result;
  }

  /**
   * 获取时长，精确到小时
   * @param  {Number} time 时间，单位是毫秒
   * @return {String}      组织好的时长字符串，一般格式为（xx天xx小时）
   */
  function _getLastDay(time) {
    var result = {
      day: Math.floor(time / (1000 * 60 * 60 * 24)),
      hour: Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    };
    var str = '';
    if (result.day > 0) {
      str += result.day + '天';
    }
    if (result.hour > 0) {
      str += result.hour + '小时';
    }
    if (result.day === 0 && result.hour === 0) {
      str = '1小时';
    }
    return str;
  }

  /**
   * 格式化时间，按照不同的格式返回不同的字符串
   * @param  {Number} time   时间戳，如果不传，或者为null，则为当前时间
   * @param  {String} format 字符串格式 (Y:年, M:月, D:日, h:小时, m:分钟, s:秒)
   * @return {String}        字符串
   */
  function _formatTime(time, format) {
    format = format || 'yyyy-MM-dd hh:mm:ss';

    var datetime = time ? new Date(time) : new Date(),
      o = {
        'M+': datetime.getMonth() + 1, //month
        'd+': datetime.getDate(), //day
        'h+': datetime.getHours(), //hour
        'm+': datetime.getMinutes(), //minute
        's+': datetime.getSeconds(), //second
        'q+': Math.floor((datetime.getMonth() + 3) / 3), //quarter
        S: datetime.getMilliseconds(), //millisecond
      };

    if (/(y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (datetime.getFullYear() + '').substr(4 - RegExp.$1.length),
      );
    }

    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length),
        );
      }
    }
    return format;
  }

  /**
   * 获取当前时间，只包含小时和分钟
   * @param  {Number} time 时间戳
   * @return {String}      对应的时间字符串
   */
  function _getNow(time) {
    return _formatTime(time, 'hh:mm');
  }

  /**
   * 创建用户数量
   * @param  {Number} n 用户数量
   * @return {Number}   经过处理的用户数量
   */
  function _createCount(n) {
    if (!$.isNumeric(n) || !n) return 0;
    n = parseInt(n, 10);
    switch (n) {
      case n < 20:
        n = n * 100;
        break;
      case n < 50:
        n = n * 80;
        break;
      default:
        n = n * 68;
        break;
    }

    return n + Math.round(Math.random() * 100);
  }

  /**
   * 生成假的房间用户数
   * @param {Number} count 房间用户数
   */
  function fakeCount(count) {
    count = count || 0;

    var unit = '';
    var fakeCount = 0;

    switch (true) {
      case count < 20:
        count = count * 100;
        break;
      case count < 50:
        count = count * 80;
        break;
      default:
        count = count * 68;
        break;
    }

    count += Math.round(Math.random() * 100);

    if (count >= 10000) {
      fakeCount = parseFloat((count / 10000).toFixed(2), 10);
      unit = '万';
      // } else if (count >= 1000) {
      //     fakeCount = parseFloat((count / 1000).toFixed(2), 10);
      //     unit = '千';
    } else {
      fakeCount = count;
    }

    return {
      visiter_count: count + unit,
      count: count,
      fakeCount: fakeCount,
      unit: unit,
    };
  }

  /**
   * 格式化数字
   * @param  {Number} num 数字
   * @return {String}        格式为1,112,234
   */
  function _formatNum(num) {
    if (!num) {
      return '0';
    }

    var strAry = num.toString().split('');

    for (var i = strAry.length - 1; i >= 0; i -= 3) {
      if (i != strAry.length - 1 && i >= 0) {
        strAry.splice(i + 1, 0, ',');
      }
    }

    return strAry.join('');
  }

  /**
   * 创建验证码
   * @return {String} 验证码地址
   */
  function _createAuthCode() {
    return MM.core.getRoot('user/authcode/' + MM.user.getToken() + '?t=' + new Date().getTime());
  }

  var DOUBLE_BYTES_REG = /[^\x00-\xff]/g; //双字符正则
  /**
   * 计算字符串长度，双字符如汉子算两个
   * @param  {String} text 字符串
   * @return {Number}      长度
   */
  function _bytesLength(text) {
    return text.replace(DOUBLE_BYTES_REG, 'aa').length;
  }

  /**
   * 百度行为统计
   * @param  {String} module 模块名
   * @param  {String} action 具体操作
   */
  function _track(module, action) {
    MM.core.debug('%cBAIDU_TRACK：%s', 'font-weight:bold;', module + (action ? '_' + action : ''));
    if (typeof _hmt != 'undefined') {
      if (typeof action != 'undefined') {
        _hmt.push(['_trackEvent', 'v2_' + module, 'v2_' + module + '_' + action]);
      } else {
        _hmt.push(['_trackEvent', 'v2_common', 'v2_common_' + module]);
      }
    }
    if (typeof MtaH5 != 'undefined') {
      if (typeof action != 'undefined') {
        MtaH5.clickStat(module + '_' + action);
      } else {
        MtaH5.clickStat('common_' + module);
      }
    }
  }

  //百度自定义变量统计
  //index：是自定义变量所占用的位置。取值为从1到5。该项必选。
  //name：是自定义变量的名字。该项必选。
  //value：就是自定义变量的值。该项必选。
  //opt_scope：是自定义变量的作用范围。该项可选。1为访客级别（对该访客始终有效），2为访次级别（在当前访次内生效），3为页面级别（仅在当前页面生效）。默认为3。
  function _setCustomVar(name, value, opt_scope) {
    if (typeof _hmt != 'undefined') {
      _hmt.push(['_setCustomVar', 1, name, value, opt_scope]);
    }
  }

  function _getAppUrl() {
    if (MM.user.getCache('ckey')) {
      return (
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.memezhibo.android&ckey=' +
        MM.user.getCache('ckey')
      );
    } else if ($.os.ios) {
      return MM.user.getCache('ios') || 'http://lnk8.cn/hgkIlc';
    } else {
      if (MM.user.getFrom() == 'MM') {
        return 'http://dl.sumeme.com/app/memezhibo_android_h5.apk';
      }
      return 'http://dl.sumeme.com/app/memezhibo_android_' + MM.user.getFrom() + '.apk';
    }
  }

  function _openDownload() {
    if ($.os.wechat && !MM.user.getCache('ckey')) {
      if (MM.live && MM.live.video) {
        MM.live.video.hide();
      }

      if ($('.ui-download-tip').length) {
        $('.ui-download-mask,.ui-download-tip').remove();
        return;
      }
      $('body').append('<div class="ui-download-mask"></div><div class="ui-download-tip"></div>');
      $('.ui-download-mask,.ui-download-tip').on('click', function () {
        $('.ui-download-mask,.ui-download-tip').remove();
        if (MM.live && MM.live.video) {
          MM.live.video.show();
        }
      });
    } else {
      MM.ui.base.openWindow(_getAppUrl());
    }
  }

  function _redirectPay() {
    MM.ui.popup.showConfirm(
      '提示',
      '<div style="text-align:left;">网页端充值功能已下线 <br/>如需充值，敬请通过“么么直播”手机APP或微信公众号进行操作</div>',
    );
  }
  function _showNoMoney(tip, room_id) {
    MM.ui.popup.showConfirm(
      '提示',
      '<div style="text-align:left;">余额不足，请充值</div>',
      _redirectPay,
    );
  }

  function _getRAF() {
    return (
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      function (cb) {
        return setTimeout(cb, 17);
      }
    );
  }

  function _getCAF() {
    return (
      window.cancelAnimationFrame ||
      window.mozCancelAnimationFrame ||
      window.webkitCancelAnimationFrame ||
      window.webkitCancelRequestAnimationFrame ||
      window.msCancelAnimationFrame ||
      window.oCancelAnimationFrame ||
      function (id) {
        clearTimeout(id);
      }
    );
  }

  function _getUserUrl(user_id) {
    if ($.os.desktop) {
      return '/u/' + user_id;
    } else {
      return 'javascript:;';
    }
  }

  /**
   * 设置 cookie
   * @param key
   * @param val       为 null 表示清空cookie
   * @param timespan    有效期，单位：毫秒；不设置 为session类型cookie
   */
  function _setCookie(key, val, second) {
    var params = {
      domain: location.hostname,
      path: '/',
    };
    if (typeof second != 'undefined' && second > 0) {
      params.expires = new Date(new Date().getTime() + second);
    }
    $.cookie(key, null);
    $.cookie(key, null, { domain: params.domain, path: '/' });

    $.cookie(key, null, { domain: '2339.com', path: '/' });
    // 暂时过度一段时间
    var domains = ['www', 'test', 'union', 'test.union', 'localhost', 'localhost.union'];
    for (var i = 0; i < domains.length; i++) {
      var item = domains[i];
      $.cookie(key, null, { domain: item + '.' + params.domain, path: '/' });
    }
    $.cookie(key, val, params);
  }

  /**
   * 获取 cookie
   * @param key
   * @returns {*}
   */
  function _getCookie(key) {
    return $.cookie(key) || '';
  }
  /**
   * 获取https，http
   * @constructor
   * @return      {[type]} [description]
   */
  function _getHttpType() {
    var http = location.href.indexOf('https') > -1 ? 'https://' : 'http://';
    return http;
  }

  /**
   * 获取https，http
   * @param num
   * @param decimal
   * @return      {[string]} [description]
   */
  function _fixedNum(num, decimal) {
    decimal = decimal || 1;
    if (typeof num === 'number') {
      if (/\./.test(num)) {
        return num.toFixed(decimal);
      }
      return num;
    }
  }

  /**
   * 简单加密算法
   * @param {String} 待解密/加密 的字符串
   * @param {Number} 密钥
   * @example 加密： a = encode('x', 123); 解密：encode(a, 'y') => 'x'
   */
  function _encode(source, number) {
    var enc = '';
    var str = '';
    var key = number;
    if (!/^[0-9]*$/.test(number)) {
      key = _.map(number, function (c, index) {
        return index % 2;
      }).join('');
    }
    str = source.toString();
    for (var i = 0; i < str.length; i++) {
      var a = str.charCodeAt(i);
      var b = a ^ key;
      enc = enc + String.fromCharCode(b);
    }
    return enc;
  }

  /**
   * 需要极验证验证的的http请求， 继承requst 所有参数，
   * @param key 唯一极验证 初始化key
   * @param options 参数配置对象，与requst方法配置一致
   * @param options.onclose 关闭极验证时候的回调
   * @param options.disableOnTest 在测试服时判断是否 进行极验证(需请求配置)
   * @param options.disableCheck 在测试服时判断是否 进行极验证（直接判断，是请求配置后的结果）
   */
  var geetestCaptchaRegsitry = {};
  var geetestData;
  function _geetestRquest(key, options) {
    var mode = MM.config.mode;
    // 当在 测试服的时候  并且 配置 disableOnTest = true
    if ((mode === 'test' || mode === 'local') && options.disableOnTest) {
      var disableCheck = options.disableCheck;
      if (typeof disableCheck === 'undefined') {
        // 如果没有该参数 表示需要请求数据
        MM.util.flint.getField(
          'meme/www',
          'disbale_geet_check_on_test',
          function (res) {
            _geetestRquest(key, _.assign({ disableCheck: res.value }, options));
          },
          function () {
            _geetestRquest(key, _.assign({ disableCheck: false }, options));
          },
        );
        return;
      } else if (disableCheck === true) {
        // 不进行极验证
        request.send(options);
        return;
      }
    }

    var captObj = geetestCaptchaRegsitry[key];
    geetestData = options.data;

    if (captObj) {
      captObj.verify();
    } else {
      request.post('authcode/geetest3', 'user', {}, function (res) {
        var geetConfig = res.data || {};
        getInitFunc()(
          {
            gt: geetConfig.gt,
            challenge: geetConfig.challenge,
            offline: !geetConfig.success,
            new_captcha: true,
            product: 'bind', // 隐藏极验证框
          },
          function (captchaObj) {
            captObj = geetestCaptchaRegsitry[key] = captchaObj;
            var opts = _.assign({}, options);
            var success = options.success;
            var error = options.error;
            var queryString =
              'geetest_v={geetest_v}&geetest_challenge={geetest_challenge}&geetest_validate={geetest_validate}&geetest_seccode={geetest_seccode}';

            if (opts.url.indexOf('&') > -1) {
              opts.url += '&' + queryString;
            } else if (opts.url.indexOf('?') > -1) {
              opts.url += '&' + queryString;
            } else {
              opts.url += '?' + queryString;
            }

            captchaObj
              .onReady(function () {
                captchaObj.verify();
              })
              .onError(function () {
                captchaObj.reset();
              })
              .onSuccess(function () {
                var result = captchaObj.getValidate() || {};

                opts.data = _.assign({}, geetestData, result, {
                  geetest_v: '3.0',
                });

                if (success) {
                  opts.success = function (d) {
                    success(d, captchaObj);
                    captchaObj.reset();
                  };
                }
                if (error) {
                  opts.error = function (d) {
                    captchaObj.reset();
                    error(d, captchaObj);
                  };
                }

                request.send(opts);
              });
            if (opts.onClose) {
              captchaObj.onClose(opts.onClose);
            }
          },
        );
      });
    }
  }

  function _parseQueryString(url) {
    var str = url;
    var items = str.split('&');
    var result = {};

    if (url.indexOf('?') > -1) {
      str = url.split('?')[1];
    }

    for (var i = 0; i < items.length; i++) {
      var arr = items[i].split('=');
      result[arr[0]] = arr[1];
    }
    return result;
  }

  /**
   * 获取 [min,max] 范围内的随机数
   * @param min
   * @param max
   * @returns {*}
   * @private
   */
  function _getRangeNum(min, max) {
    return Math.floor(Math.random() * (max + 1 - min)) + min;
  }

  /**
   * 获取随机字符串长度
   * @param maxLen
   * @returns {string}
   */
  function _getRandomString(maxLen) {
    if (!maxLen) {
      maxLen = 6;
    }
    var str = Math.random().toString(36).substring(2);
    while (str.length < maxLen) {
      str += Math.random().toString(36).substring(2);
    }
    return str.substring(0, maxLen);
  }

  /**
   * 获取人民币格式
   * @param num，单位：分
   * @private
   */
  function _getCny(num) {
    return ((num || 0) / 100).toFixed(2);
  }

  function _getDate(time) {
    var datetime;
    if (time instanceof Date) {
      datetime = time;
    } else {
      datetime = time ? new Date(time) : new Date();
    }
    return datetime;
  }

  function getMonthFirstDate(time) {
    var date = time ? new Date(time) : new Date();
    date.setDate(1);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function getMonthLastDate(time) {
    var date = _getDate(time);
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1).getTime();
    var oneDay = 1000 * 60 * 60 * 24;
    var lastTime = new Date(nextMonthFirstDay - oneDay);
    return new Date(date.getFullYear(), date.getMonth(), lastTime.getDate());
  }

  function getNextMonthFirstDate(time) {
    var date = _getDate(time);
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    return new Date(date.getFullYear(), nextMonth, 1);
  }

  //Key agreed with the backend
  var DESKey = 'd2a04d71301a8915217dd5faf81d12cffd6cd958';

  //encryption
  function encryptedDES(data) {
    var keyHex = CryptoJS.enc.Utf8.parse(DESKey);
    //The mode is ECB padding is Pkcs7
    var encrypted = CryptoJS.DES.encrypt(data, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    //Encrypted is a hexadecimal string
    return encrypted.ciphertext.toString();
  }

  //Decrypt
  function decryptedDES(data) {
    var keyHex = CryptoJS.enc.Utf8.parse(DESKey);
    var decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(data),
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      },
    );
    //Output the decrypted content in the form of utf-8
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  return {
    setCookie: _setCookie,
    getCookie: _getCookie,
    lastTime: _lastTime,
    getLastDay: _getLastDay,
    formatTime: _formatTime,
    getNow: _getNow,
    createCount: _createCount,
    formatNum: _formatNum,
    createAuthCode: _createAuthCode,
    bytesLength: _bytesLength,
    track: _track,
    setCustomVar: _setCustomVar,
    getAppUrl: _getAppUrl,
    redirectPay: _redirectPay,
    showNoMoney: _showNoMoney,
    openDownload: _openDownload,
    getRAF: _getRAF,
    getCAF: _getCAF,
    getUserUrl: _getUserUrl,
    getHttpType: _getHttpType,
    fixedNum: _fixedNum,
    geetestRquest: _geetestRquest,
    encode: _encode,
    parseQueryString: _parseQueryString,
    fakeCount: fakeCount,
    getRangeNum: _getRangeNum,
    getRandomString: _getRandomString,
    getCny: _getCny,
    getMonthFirstDate: getMonthFirstDate,
    getMonthLastDate: getMonthLastDate,
    getNextMonthFirstDate: getNextMonthFirstDate,
    encryptedDES: encryptedDES,
    decryptedDES: decryptedDES,
  };
});
